/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MinimalProductDto } from '../../models/minimal-product-dto';

export interface ProductGetAllEditorMenus$Plain$Params {
}

export function productGetAllEditorMenus$Plain(http: HttpClient, rootUrl: string, params?: ProductGetAllEditorMenus$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MinimalProductDto>>> {
  const rb = new RequestBuilder(rootUrl, productGetAllEditorMenus$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MinimalProductDto>>;
    })
  );
}

productGetAllEditorMenus$Plain.PATH = '/api/Product/minimal';
